/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

// import * as actions from '../actions/initializeValues';
// import { demoShipments } from '../util/demoShipments'
// import { dummyDataContainerInfo, coors } from '../util/testJSON'
// import { shipmentListData, shipmentActivityDetail, shipmentsCurrentLocation } from '../data/shipmentData'

import {
  saveBOLInfoField,
  saveBOLInfoObject,
  saveBOLInfoDateField,
  saveContainer,
  deleteContainer
} from '../api/setFormData'

const initialState = {
  // initialValues
}

export default function BOLInfoReducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_BOL': {
      return Object.assign({}, state, { ...action.payload })
    }
    case 'UPDATE_BOL_INFO_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload })
    }
    case 'UPDATE_CONTAINER_FIELD': {
      let container = state.container.slice()
      container[action.index][action.field] = action.payload
      return Object.assign({}, state, { container })
    }
    case 'UPDATE_ACTOR_ADDRESS': {
      return Object.assign({}, state, { ...action.payload })
    }
    case 'ADD_CONTAINER': {
      let newContainer = state.container.slice()
      newContainer.push(action.newContainer)
      return Object.assign({}, state, { container: newContainer })
    }
    case 'REMOVE_ADDITIONAL_CONTAINER': {
      let container = state.container
        .slice(0, action.payload)
        .concat(state.container.slice(action.payload + 1))
      return (
        deleteContainer(
          state.container[action.payload].containerId,
          state.container[action.payload].number
        ).then(response => console.log(response)),
        Object.assign({}, state, { container })
      )
    }
    case 'UPDATE_IT_DATE_FIELD': {
      return Object.assign({}, state, {
        itDate: Object.assign({}, state.itDate, {
          epochs: action.payload
        })
      })
    }
    case 'INITIALIZE_SHIPID': {
      return Object.assign({}, state, { shipId: action.payload })
    }
    case 'SAVE_BOL_OBJECT': {
      saveBOLInfoObject(action.fieldc, action.objectX)
      return state
    }
    case 'SAVE_BOL_FIELD': {
      saveBOLInfoField(action.field, state[action.field])
      return state
    }
    case 'SAVE_BOL_DATE_FIELD': {
      return (
        saveBOLInfoDateField([action.field], action.payload, state.shipId).then(
          response => console.log(response)
        ),
        Object.assign({}, state, {
          [action.field]: Object.assign({}, ...[action.field], {
            epochs: action.payload
          })
        })
      )
    }
    case 'UPDATE_BOL_OBJECT': {
      let newObj = Object.assign({}, state[action.object])
      newObj[action.field] = action.payload
      return Object.assign({}, state, { [action.object]: newObj })
    }
    // case 'SAVE_CONTAINER': {
    //   saveContainer(
    //     state.container[action.index].containerId,
    //     action.field,
    //     state.container[action.index][action.field]
    //   )
    //   return state
    // }
    case 'UPDATE_BOL_INFO_WARNING': {
      return Object.assign({}, state, { warning: action.warnings })
    }
    default:
      return state
  }
}
